import React from 'react'
import { Link } from 'react-router-dom'
import linkArrow from '../../asset/arrowRight.svg'
import './menu.css'


export const Menu = () => {
  return (
    <section id="menu" className="menu">
        <Link to="/about">
          <div id='menuWorkLink' className="menuWorkLink">
            about <p className='itsthisway'>
              COME<br /> THIS<br /> WAY
            <img src={linkArrow} alt="" />
            </p>
          </div>
        </Link>
        <Link to="/works">
          <div id='menuWorkLink' className="menuWorkLink">
            work<p className='itsthisway'>
              COME<br /> THIS<br /> WAY
            <img src={linkArrow} alt="" />
            </p>
          </div>
        </Link>
        <Link to="/contact">
          <div id='menuWorkLink' className="menuWorkLink bb">
            cantact<p className='itsthisway'>
              COME<br /> THIS<br /> WAY
            <img src={linkArrow} alt="" />
            </p>
          </div>
        </Link>
      </section>
  )
}
